import "../../../../../../../styles/scroll.scss";

const TxtReader = (props: { txtFileValue: string; isLoading: boolean; textOnChange: any }) => {
    const changeHandler = (e: any) => {
        props.textOnChange(e.target.value);
    };

    return (
        <div className="w-7/12 h-auto overflow-auto flex items-center justify-center">
            {props.isLoading ? (
                <div
                    className={`min-h-[60vh] sm:min-h-[18rem] max-h-[70vh] flex px-2 w-full flex-1 rounded-[10px] overflow-hidden shadow-sm relative transition-all skeleton`}
                />
            ) : (
                <textarea
                    defaultValue={props.txtFileValue}
                    onChange={changeHandler}
                    className={`custom-scrollbar min-h-[60vh] sm:min-h-[18rem] max-h-[70vh] w-full p-4 text-sm text-secondary-800 bg-secondary-200 rounded-[10px] outline-none leading-snug`}
                />
            )}
        </div>
    );
};

export default TxtReader;
